import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: 78px;
  justify-content: center;

  & div {
    max-width: 100%;
  }

  @media (max-width: 400px) {
    transform: scale(0.9);
    transform-origin: center;
  }
`;
